import { createSelector } from "@reduxjs/toolkit";
import { ApplicationState } from "app/store";

import { NotificationBranch } from "./types";

export const getNotificationBranch = (state: ApplicationState) => state.notification;
export const selectNotificationTemplate = createSelector(getNotificationBranch, (b: NotificationBranch) => b.template);
export const selectNotificationOptions = createSelector(getNotificationBranch, (b: NotificationBranch) => b.options);
